import React from 'react';
import { Dna } from 'lucide-react';
export function SiteFooter() {
  return <footer className="w-full border-t border-white/[0.06] bg-ink-950 px-5 py-9 sm:px-6 sm:py-12" data-id="element-275" data-mp="3r89gvii7pbl6">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-4 text-center sm:gap-5" data-id="element-276" data-mp="3mhj5non3ueik">
        <span className="inline-flex items-center gap-2 font-mono text-[10.5px] uppercase tracking-[0.2em] text-gold-400/80" data-id="element-277" data-mp="3hig268mrwgcp">
          <Dna className="h-3.5 w-3.5" strokeWidth={1.8} aria-hidden="true" data-id="element-278" data-mp="3dh4kqqe1z1fl" />
          Protocolo Lujo de Farmacia
        </span>
        <p className="max-w-2xl text-[11.5px] leading-relaxed text-[#6f7684]" data-id="element-279" data-mp="38g6urrmsx33j">
          Este material es informativo y educativo. No constituye consejo médico, diagnóstico ni
          prescripción. Consulte a un profesional de la salud calificado antes de iniciar cualquier
          protocolo. Los resultados varían según el individuo.
        </p>
        <p className="font-mono text-[10.5px] text-[#5b6270]" data-id="element-280" data-mp="wsgzadkl4xgy">
          © {new Date().getFullYear()} Protocolo Lujo de Farmacia · Todos los derechos reservados
        </p>
      </div>
    </footer>;
}